import { apiClient } from "@/api"
import { CurrentUserContext } from "@/contexts/CurrentUser"
import React, { useEffect, useState } from "react"

const fetchCurrentUser = async () => {
  try {
    const response = await apiClient.get("/api/v2/users/current_user")
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message)
  }
}

export const CurrentUserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchUser = async () => {
    try {
      setIsLoading(true)
      setError(null)
      const user = await fetchCurrentUser()
      setCurrentUser(user)
    } catch (err) {
      setError(err.message)
      setCurrentUser(null)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchUser()
  }, [])

  const contextValue = {
    currentUser,
    isLoading,
    error,
    refetchUser: fetchUser,
  }

  return <CurrentUserContext.Provider value={contextValue}>{children}</CurrentUserContext.Provider>
}

export default CurrentUserProvider
